'use strict';

angular
    .module('app', [
        'ngMessages',

        'app.error',
        'app.footer',
        'app.front',
        'app.studies',
        'app.user',

        'body-layout',
        'custom-validator',
        'gettext',
        'inetsys.datepicker',
        'inlineHelp',
        'link-disabled',
        'menu',
        'nl2br',
        'page-title',
        'portal.i18n',
        'security-redirect',
        'security-redirect-autoreload-session',
        'sharecrf.date-format',
        'sharecrf.gtm',
        'sharecrf.login-info',
        'sharecrf.news',
        'sharecrf.environment',
    ])
    // Url settings
    .config(['$locationProvider', 'BodyLayoutProvider', function($locationProvider, BodyLayoutProvider) {
        // Clean URLs
        $locationProvider.html5Mode(true);

        // Body class
        BodyLayoutProvider.setLayout('clean', [
            'login',
            'signup',
            'signup-success',
            'signup-pending',
            'validate-success',
            'validate-error',
            'recover-password',
            'recover-password-sent',
            'change-password',
            'change-password-error',
        ]);
    }])
    // SDK version settings
    .config(['ShareCrfSDKProvider', '$windowProvider', function(ShareCrfSDKProvider, $windowProvider) {
        ShareCrfSDKProvider.setOrigin('Portal-ShareCRF@APP_VERSION');

        var $window = $windowProvider.$get();
        if (angular.isDefined($window.jstz)) {
            ShareCrfSDKProvider.setTimeZone($window.jstz.determine().name());
        }
        ShareCrfSDKProvider.setBaseUrl('/live/api');
    }])
    // Session management
    .config(['SecurityRedirectProvider', function(SecurityRedirectProvider) {
        SecurityRedirectProvider.url = '/login?warn=session-expired';
    }])
    // Define action to execute after clicking in logout button
    .config(['LogoutManagerProvider', '$windowProvider', function(LogoutManagerProvider, $windowProvider) {
        var $window = $windowProvider.$get();
        LogoutManagerProvider.onLogout = ['$state', function($state) {
            $window.location = '/login?message=successful-logout';
            return;
        }];
    }])
    // Define service to manage authentication in routes
    .config(['RouteAuthProvider', function(RouteAuthProvider) {
        RouteAuthProvider.init = ['AccountManager', function(AccountManager) {
            return AccountManager.init;
        }];
        RouteAuthProvider.getLoggedUser = ['AccountManager', function(AccountManager) {
            return AccountManager.getLoggedUser;
        }];
        RouteAuthProvider.isLogged = ['AccountManager', function(AccountManager) {
            return AccountManager.isLogged;
        }];
        RouteAuthProvider.hasPermission = ['AccountManager', function(AccountManager) {
            return AccountManager.hasPermission;
        }];
    }])
    // GARU-4642 Date formats
    .config([
        'ShareCrfDateFormatProvider',
        'InetsysDatepickerConfigProvider',
        function(ShareCrfDateFormatProvider, InetsysDatepickerConfigProvider) {
            ShareCrfDateFormatProvider
                .addFormat('timeshort', 'lll')
                .addFormat('timelong', 'LLL')
                .addFormat('datelong', 'LL');

            InetsysDatepickerConfigProvider.options = {
                viewFormat: 'DD MMM YYYY',
            };

            angular.injector(['ngCookies']).invoke(['$cookies', function($cookies) {
                var countriesStartingInSunday = ['JP', 'CA', 'US'];
                var weekStartDay = 1; // Lunes por defecto
                if (countriesStartingInSunday.indexOf($cookies.get('COUNTRY')) !== -1) {
                    weekStartDay = 0;
                }
                InetsysDatepickerConfigProvider.options.weekStartDay = weekStartDay;
            }]);

            moment && moment.updateLocale('es', {
                // Abreviaturas de días de la semana con una sola letra
                weekdaysMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
                // Abreviaturas de meses sin punto
                monthsShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
                // Formatos sin literales "27 de octubre" => "27 octubre"
                longDateFormat: {
                    LT: 'HH:mm',
                    LTS: 'HH:mm:ss',
                    L: 'DD/MM/YYYY', // eslint-disable-line id-length
                    l: 'D/M/YYYY', // eslint-disable-line id-length
                    LL: 'D MMMM YYYY',
                    ll: 'D MMM YYYY',
                    LLL: 'LL LT',
                    lll: 'll LT',
                    LLLL: 'dddd, LLL',
                    llll: 'ddd, lll',
                },
            });

            moment && moment.updateLocale('de', {
                // Abreviaturas de meses sin punto
                monthsShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
            });
        },
    ])
    // Load user if there is an open session
    .run(['AccountManager', 'SecurityRedirect', function(AccountManager, SecurityRedirect) {
        SecurityRedirect.init();
        AccountManager.init();
    }])
    .run(['ShareCrfLanguageService', function(ShareCrfLanguageService) {
        ShareCrfLanguageService.initialize();
    }])
    // Language settings - GARU2610
    .run(['Event', 'ShareCrfLanguageService', function(Event, ShareCrfLanguageService) {
        Event.on('login', function() {
            ShareCrfLanguageService.reload();
        });
        Event.on('session', function() {
            ShareCrfLanguageService.reload();
        });
    }])
    // GARU-3122 Plantillas de ayuda
    .run(['$templateCache', 'gettextCatalog', function($templateCache, gettextCatalog) {
        $templateCache.put('templates/inline-help-button.html',
            '<button type="button" class="inline-help-trigger" ng-click="toggle()">' + gettextCatalog.getString('Ayuda') + '</button>\n' +
            '');
        $templateCache.put('templates/inline-help.html',
            '<div ng-if="inlineHelpIsShown" class="inline-help-panel">\n' +
            '    <button type="button" class="inline-help-close" ng-click="inlineHelpToggle()" title="' + gettextCatalog.getString('Ocultar ayuda') + '">' + gettextCatalog.getString('Cerrar') + '</button>\n' +
            '    <h4>' + gettextCatalog.getString('Ayuda') + '</h4>\n' +
            '    <div class="inline-help-content" ng-transclude></div>\n' +
            '</div>\n' +
            '');

        $templateCache.put('templates/inetsys-calendar.html',
            '<div class="inetsys-calendar" ng-if="calendar.isVisible()">\n' +
            '    <div class="inetsys-calendar-years" ng-if="calendar.mode === \'year\'">\n' +
            '        <ul class="years">\n' +
            '            <li class="nav-prev"><button type="button" ng-click="calendar.showPreviousYears()">' + gettextCatalog.getString('Años anteriores') + '</button></li>\n' +
            '            <li ng-repeat="year in calendar.years" ng-class="{selected: year.selected}">\n' +
            '                <button type="button" ng-click="calendar.selectYear(year)">{{ year.id }}</button>\n' +
            '            </li>\n' +
            '            <li class="nav-next"><button type="button" ng-click="calendar.showNextYears()">' + gettextCatalog.getString('Años siguientes') + '</button></li>\n' +
            '        </ul>\n' +
            '    </div>\n' +
            '    <div class="inetsys-calendar-months" ng-if="calendar.mode === \'month\'">\n' +
            '        <ul class="inetsys-calendar-nav">\n' +
            '            <li class="nav-prev"><button type="button" ng-click="calendar.showPrevYear()">' + gettextCatalog.getString('Año anterior') + '</button></li>\n' +
            '            <li><button type="button" ng-click="calendar.setMode(\'year\')">{{ calendar.currentDate.format(\'YYYY\') }}</button></li>\n' +
            '            <li class="nav-next"><button type="button" ng-click="calendar.showNextYear()">' + gettextCatalog.getString('Año siguiente') + '</button></li>\n' +
            '        </ul>\n' +
            '        <ul class="year-months">\n' +
            '            <li ng-repeat="month in calendar.months" ng-class="{selected: month.selected}">\n' +
            '                <button type="button" ng-click="calendar.selectMonth(month)">{{ ::month.label }}</button>\n' +
            '            </li>\n' +
            '        </ul>\n' +
            '    </div>\n' +
            '    <div class="inetsys-calendar-days" ng-if="calendar.mode === \'day\'">\n' +
            '        <ul class="inetsys-calendar-nav">\n' +
            '            <li class="nav-prev"><button type="button" ng-click="calendar.showPrevMonth()">' + gettextCatalog.getString('Mes anterior') + '</button></li>\n' +
            '            <li><button type="button" ng-click="calendar.setMode(\'month\')">{{ calendar.currentDate.format(\'MMMM\') }} {{ calendar.currentDate.format(\'YYYY\') }}</button></li>\n' +
            '            <li class="nav-next"><button type="button" ng-click="calendar.showNextMonth()">' + gettextCatalog.getString('Mes siguiente') + '</button></li>\n' +
            '        </ul>\n' +
            '        <ul class="month-days">\n' +
            '            <li ng-repeat="weekDay in ::calendar.weekDays"><strong>{{ ::weekDay }}</strong></li>\n' +
            '            <li ng-repeat="day in calendar.days" ng-class="{selected: day.selected, today: day.today, \'prev-month\': day.prevMonth, \'next-month\': day.nextMonth, disabled: day.disabled}">\n' +
            '                <button type="button" ng-click="calendar.selectDay(day)" ng-disabled="::day.disabled">{{ ::day.id.format(\'DD\') }}</button>\n' +
            '            </li>\n' +
            '        </ul>\n' +
            '    </div>\n' +
            '    <div class="inetsys-calendar-footer">\n' +
            '        <button type="button" class="clear" ng-click="calendar.clearDate()">' + gettextCatalog.getString('Borrar') + '</button>\n' +
            '        <button type="button" class="today" ng-click="calendar.selectToday()">' + gettextCatalog.getString('Hoy') + '</button>\n' +
            '        <button type="button" class="close" ng-click="calendar.closeCalendar()">' + gettextCatalog.getString('Cerrar') + '</button>\n' +
            '    </div>\n' +
            '</div>\n' +
            '');
    }]);
